import React, { Component } from 'react';
import { OrderForm } from './OrderForm';

export class OrdersPreview extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        var data = this.props.data;
        if (data && data.orders.length > 0) {
            return (<div className="print-container" style={{ margin: "0", padding: "0" }}>
                {data.orders.map(x => <div className="h-full"><OrderForm model={x} isNew={false} id={x.id} printMode={true} />
                    </div>)}
            </div>);
        }
        return null;
    }
}